// PatientDetails.tsx
import React from 'react'
import { Row, Col, Table, Tab } from 'react-bootstrap'
import './PatientCardStyle.css'
import { calculateAge } from '@utils/dob.utils'
type PatientDetailsProps = {
  patient: {
    gender: string
    dob: string
    phone: string
    work_phone: string
    cellphone: string
    fax: string
    email: string
    ssn: string
    address_1: string
    address_2: string
    city: string
    state: string
    zip: string
    marital_status: string
    chart_number: string
    financing: string
    hygienist: string
    dentist: string
    balance_due?: number
  }
}

const PatientDetails: React.FC<PatientDetailsProps> = ({ patient }) => {
  return (
    <Tab.Pane eventKey="first">
      <Row>
        <Col>
          <h4 className="p-2">General</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Gender</th>
                <th scope="col">Age</th>
                <th scope="col">Date of Birth</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{patient.gender}</td>
                <td>{calculateAge(patient.dob)}</td>
                <td>{patient.dob}</td>
              </tr>
            </tbody>
          </Table>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Phone</th>
                <th scope="col">Mobile</th>
                <th scope="col">Fax</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{patient.phone}</td>
                <td>{patient.cellphone}</td>
                <td>{patient.fax}</td>
              </tr>
            </tbody>
          </Table>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Work phone</th>
                <th scope="col">Email</th>
                <th scope="col">SSN</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{patient.work_phone}</td>
                <td>{patient.email}</td>
                <td>{patient.ssn}</td>
              </tr>
            </tbody>
          </Table>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Marital status</th>
                <th scope="col">Chart number</th>
                <th scope="col">Insurance/Financing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{patient.marital_status}</td>
                <td>{patient.chart_number}</td>
                <td>{patient.financing}</td>
              </tr>
            </tbody>
          </Table>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Hygienist</th>
                <th scope="col">Dentist</th>
                <th scope="col">Balance due</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{patient.hygienist}</td>
                <td>{patient.dentist}</td>
                <td>{patient.balance_due}</td>
              </tr>
            </tbody>
          </Table>
          <Table className="tablePatientDetails">
            <thead>
              <tr>
                <th scope="col">Address 1</th>
                <th scope="col">Address 2</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {patient.address_1} {patient.city} {patient.state}{' '}
                  {patient.zip}
                </td>
                <td>
                  {patient.address_2} {patient.city} {patient.state}{' '}
                  {patient.zip}
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default PatientDetails
